import api from "../../config/client.axios.api";

export const getAllAccountApiRequest = async () => {
  const response = await api.get(`/account`);
  return response.data;
};
